import React, { Dispatch, SetStateAction } from 'react';

import styles from './SlotArchiveFiltersModalFooter.module.scss';

export type SlotArchiveFiltersModalFooterProps = {
  isSelected: boolean;
  resetLabel: string;
  dismissModalLabel: string;
  setOn: Dispatch<SetStateAction<boolean>>;
  handleResetClick: Function;
  handleClickViewResults: Function;
};

export const SlotArchiveFiltersModalFooter = ({
  resetLabel,
  dismissModalLabel,
  isSelected,
  setOn,
  handleResetClick,
  handleClickViewResults,
}: SlotArchiveFiltersModalFooterProps) => {
  if (isSelected) {
    return (
      <div className={styles.footer}>
        <button type="button" className={styles.reset} onClick={() => handleResetClick()}>
          {resetLabel}
        </button>

        <button
          className={styles.dismiss}
          type="button"
          onClick={() => {
            setOn(false);
            handleClickViewResults();
          }}
        >
          {dismissModalLabel}
        </button>
      </div>
    );
  }

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <React.Fragment />
  );
};
